import PropTypes from 'prop-types'
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Toolbar,
  Typography,
  Checkbox,
  IconButton,
  Tooltip
} from '@material-ui/core'

import { getCellHeader } from '../utils/tableLib'

import DeleteIcon from '@material-ui/icons/DeleteSharp'

export function EnhancedTableHead (props) {
  const {
    tableCols,
    buttons,
    showTags,
    allowSelection,
    allowSelectAll,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    iconCol,
  } = props

  const createSortHandler = property => event => {
    onRequestSort(event, undefined, property)
  }

  return (
    <TableHead>
      <TableRow>
        {allowSelection && (
          <TableCell padding='checkbox'>
            {allowSelectAll && (
              <Checkbox
                color='primary'
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={rowCount > 0 && numSelected === rowCount}
                onChange={onSelectAllClick}
                inputProps={{
                  'aria-label': 'select all'
                }}
              />
            )}
          </TableCell>
        )}
        {iconCol && <TableCell />}
        {tableCols &&
          tableCols.map(col => (
            <TableCell
              key={col}
              align={'left'}
              padding={'normal'}
              sortDirection={orderBy === col ? order : false}
            >
              <TableSortLabel
                active={orderBy === col}
                direction={orderBy === col ? order : 'desc'}
                onClick={createSortHandler(col)}
              >
                {getCellHeader(col)}
              </TableSortLabel>
            </TableCell>
          ))}
        {showTags && (
          <TableCell key={'Tags'} align={'left'} padding={'normal'}>
            Tags
          </TableCell>
        )}
        {buttons && (
          <TableCell key={'Buttons'} align={'left'} padding={'normal'}>
            Actions
          </TableCell>
        )}
      </TableRow>
    </TableHead>
  )
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired
}

export function EnhancedTableToolbar (props) {
  const { heading, numSelected } = props

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 }
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color='inherit'
          variant='subtitle1'
          component='div'
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant='h6'
          id='tableTitle'
          component='div'
        >
          {heading}
        </Typography>
      )}

      {numSelected > 0 && (
        // TODO: Replace placeholder for selection actions with real multi-material actions
        <Tooltip title='Delete'>
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  )
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired
}
